var $4c587b7138d23ff0$exports = {};
$4c587b7138d23ff0$exports = {
    "info": `Inform\xe1ci\xf3`,
    "negative": `Hiba`,
    "notice": `Figyelmeztet\xe9s`,
    "positive": `Siker`
};


export {$4c587b7138d23ff0$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
